<template>
    <div>
        <b-form v-if="!isExport" inline class="d-inline-block">
            <b-form-select
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="null"
                v-model="selectedCategory"
                :options="problemCategories"
            >
                <template v-slot:first>
                    <option :value="null">All categories</option>
                </template>
            </b-form-select>
        </b-form>
        <div class="fail-category-chart-container">
            <chart-loader :loading="loading.problemCategories"></chart-loader>
            <fail-category-chart
                :height="210"
                :chart-data="chartdata"
                :options="chartOptions"
                v-if="isExport && chartdata.labels.length"
            />
            <fail-category-chart
                :chart-data="chartdata"
                :options="chartOptions"
                v-if="!isExport && chartdata.labels.length"
            />
            <div
                class="alert alert-warning"
                v-if="chartdata.labels.length <= 0"
            >
                No data found for selection
            </div>
        </div>
    </div>
</template>

<script>
import ChartLoader from "../Charts/ChartLoader";
import FailCategoryChart from "../Charts/FailCategoryChart";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "FailCategoryContainer",
  components: {
    FailCategoryChart,
    ChartLoader
  },
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("en-US", options).format(value);
    }
  },
  props: {
    base_product: {
      default: null,
      type: Number
    },
    isExport: {
      default: false,
      type: Boolean
    },
    product_variant: {
      default: null,
      type: Number
    }
  },
  data() {
    return {
      selectedCategory: null
    };
  },
  computed: {
    ...mapGetters({
      problemCategories: "analytics/getProblemCategoriesForFormSelect",
      chartdata: "analytics/getDefectsChartData"
    }),
    ...mapState("analytics", {
      start_date: state => state.start_date,
      end_date: state => state.end_date,
      unit: state => state.unit,
      loading: state => state.loading
    }),
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: this.isMobile ? "top" : "left"
        }
      };
    }
  },
  watch: {
    selectedCategory: {
      handler(category) {
        this.getDefectsData({
          category: category,
          start_date: this.start_date,
          end_date: this.end_date,
          unit: this.unit,
          base_product: this.base_product,
          product_variant: this.product_variant
        });
      }
    },
    base_product(n) {
      this.getDefectsData({
        category: null,
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit,
        base_product: n,
        product_variant: this.product_variant
      });
    },
    product_variant(n) {
      this.getDefectsData({
        category: null,
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit,
        base_product: this.base_product,
        product_variant: n
      });
    }
  },
  mounted() {
    if (!this.isExport) {
      this.getProblemCategories({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getDefectsData({
        category: null,
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit,
        base_product: this.base_product,
        product_variant: this.product_variant
      });
      this.$root.$on("failCat", () => {
        this.reRender();
      });
    }
  },
  methods: {
    ...mapActions({
      getProblemCategories: "analytics/getProblemCategories",
      getDefectsData: "analytics/getDefectsData"
    }),
    reRender() {
      this.getProblemCategories({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getDefectsData({
        category: this.selectedCategory,
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit,
        base_product: this.base_product,
        product_variant: this.product_variant
      });
    }
  }
};
</script>

<style scoped>
.form-inline .custom-select {
  margin-bottom: 15px !important;
}
</style>
